import {
  dangerCardHeader,
  infoCardHeader,
  octinionLightCardHeader,
  primaryCardHeader,
  successCardHeader,
  warningCardHeader,
} from "assets/jss/material-dashboard-pro-react.jsx";

const cardIconStyle = {
  cardIcon: {
    "&$warningCardHeader,&$successCardHeader,&$dangerCardHeader,&$infoCardHeader,&$primaryCardHeader,&$octinionLightCardHeader": {
      borderRadius: "3px",
      backgroundColor: "#999",
      padding: "15px",
      marginTop: "-20px",
      marginRight: "15px",
      float: "left"
    }
  },
  warningCardHeader,
  successCardHeader,
  dangerCardHeader,
  infoCardHeader,
  primaryCardHeader,
  octinionLightCardHeader,
};

export default cardIconStyle;
